import React from 'react';
import { Layout } from '../components/Layout';
import { Calendar as CalendarIcon, Clock, Phone, Video, MapPin, ChevronLeft, ChevronRight } from 'lucide-react';
import { format, addDays, startOfWeek, addHours } from 'date-fns';
export function Calendar() {
  const today = new Date();
  const weekStart = startOfWeek(today, {
    weekStartsOn: 1
  });
  const days = Array.from({
    length: 7
  }).map((_, i) => addDays(weekStart, i));
  const hours = Array.from({
    length: 10
  }).map((_, i) => i + 8); // 8 AM to 5 PM
  return <Layout data-id="element-169">
      <div className="max-w-7xl mx-auto space-y-6" data-id="element-170">
        <div className="flex justify-between items-end" data-id="element-171">
          <div data-id="element-172">
            <h1 className="text-2xl font-bold text-slate-900" data-id="element-173">Calendar</h1>
            <p className="text-slate-500 mt-1" data-id="element-174">
              Your upcoming appointments and scheduled calls.
            </p>
          </div>
          <div className="flex items-center gap-4" data-id="element-175">
            <div className="flex items-center gap-2 bg-white border border-slate-200 rounded-lg p-1 shadow-sm" data-id="element-176">
              <button className="p-1 hover:bg-slate-100 rounded text-slate-600" data-id="element-177">
                <ChevronLeft size={20} data-id="element-178" />
              </button>
              <span className="text-sm font-medium px-2" data-id="element-179">
                {format(today, 'MMMM yyyy')}
              </span>
              <button className="p-1 hover:bg-slate-100 rounded text-slate-600" data-id="element-180">
                <ChevronRight size={20} data-id="element-181" />
              </button>
            </div>
            <button className="px-4 py-2 bg-blue-600 text-white rounded-md text-sm font-medium hover:bg-blue-700 transition-colors shadow-sm" data-id="element-182">
              New Event
            </button>
          </div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-4 gap-8" data-id="element-183">
          <div className="lg:col-span-3 bg-white rounded-xl border border-slate-200 shadow-sm overflow-hidden" data-id="element-184">
            <div className="grid grid-cols-8 border-b border-slate-200 bg-slate-50" data-id="element-185">
              <div className="p-3 border-r border-slate-200" data-id="element-186"></div>
              {days.map((day, i) => <div key={i} className={`p-3 text-center border-r border-slate-200 last:border-r-0 ${format(day, 'd') === format(today, 'd') ? 'bg-blue-50' : ''}`} data-id="element-187">
                  <div className="text-xs font-semibold text-slate-500 uppercase" data-id="element-188">
                    {format(day, 'EEE')}
                  </div>
                  <div className={`text-lg mt-1 ${format(day, 'd') === format(today, 'd') ? 'text-blue-600 font-bold' : 'text-slate-900'}`} data-id="element-189">
                    {format(day, 'd')}
                  </div>
                </div>)}
            </div>

            <div className="overflow-y-auto max-h-[600px]" data-id="element-190">
              {hours.map(hour => <div key={hour} className="grid grid-cols-8 border-b border-slate-100 last:border-b-0 min-h-[80px]" data-id="element-191">
                  <div className="p-2 border-r border-slate-200 text-xs font-medium text-slate-400 text-right" data-id="element-192">
                    {hour > 12 ? `${hour - 12} PM` : hour === 12 ? '12 PM' : `${hour} AM`}
                  </div>
                  {days.map((day, i) => <div key={i} className="p-1 border-r border-slate-100 last:border-r-0 relative" data-id="element-193">
                      {/* Mock Event */}
                      {hour === 10 && i === 2 && <div className="absolute inset-1 bg-blue-100 border border-blue-200 rounded p-1.5 overflow-hidden" data-id="element-194">
                          <div className="text-xs font-semibold text-blue-800 truncate" data-id="element-195">
                            Call Sarah J.
                          </div>
                          <div className="text-[10px] text-blue-600 truncate mt-0.5" data-id="element-196">
                            10:00 - 10:30 AM
                          </div>
                        </div>}
                      {hour === 14 && i === 4 && <div className="absolute inset-1 bg-purple-100 border border-purple-200 rounded p-1.5 overflow-hidden" data-id="element-197">
                          <div className="text-xs font-semibold text-purple-800 truncate" data-id="element-198">
                            Refi Review
                          </div>
                          <div className="text-[10px] text-purple-600 truncate mt-0.5" data-id="element-199">
                            2:00 - 3:00 PM
                          </div>
                        </div>}
                    </div>)}
                </div>)}
            </div>
          </div>

          <div className="bg-white rounded-xl border border-slate-200 shadow-sm p-6 h-fit" data-id="element-200">
            <h2 className="text-lg font-semibold text-slate-900 mb-6" data-id="element-201">
              Today's Agenda
            </h2>
            <div className="space-y-4" data-id="element-202">
              <div className="flex gap-4 group" data-id="element-203">
                <div className="text-sm font-medium text-slate-900 w-16 shrink-0 pt-1" data-id="element-204">
                  10:00 AM
                </div>
                <div className="flex-1 p-3 border border-slate-100 rounded-lg bg-blue-50/50 group-hover:border-blue-200 transition-colors" data-id="element-205">
                  <div className="font-medium text-slate-900 text-sm" data-id="element-206">
                    Call Sarah Jenkins
                  </div>
                  <div className="text-xs text-slate-500 flex items-center gap-1 mt-1.5" data-id="element-207">
                    <Phone size={12} data-id="element-208" /> Pre-approval follow-up
                  </div>
                </div>
              </div>

              <div className="flex gap-4 group" data-id="element-209">
                <div className="text-sm font-medium text-slate-900 w-16 shrink-0 pt-1" data-id="element-210">
                  1:00 PM
                </div>
                <div className="flex-1 p-3 border border-slate-100 rounded-lg bg-slate-50 group-hover:border-slate-200 transition-colors" data-id="element-211">
                  <div className="font-medium text-slate-900 text-sm" data-id="element-212">
                    Team Meeting
                  </div>
                  <div className="text-xs text-slate-500 flex items-center gap-1 mt-1.5" data-id="element-213">
                    <Video size={12} data-id="element-214" /> Zoom
                  </div>
                </div>
              </div>

              <div className="flex gap-4 group" data-id="element-215">
                <div className="text-sm font-medium text-slate-900 w-16 shrink-0 pt-1" data-id="element-216">
                  2:30 PM
                </div>
                <div className="flex-1 p-3 border border-slate-100 rounded-lg bg-purple-50/50 group-hover:border-purple-200 transition-colors" data-id="element-217">
                  <div className="font-medium text-slate-900 text-sm" data-id="element-218">
                    Refinance Review
                  </div>
                  <div className="text-xs text-slate-500 flex items-center gap-1 mt-1.5" data-id="element-219">
                    <MapPin size={12} data-id="element-220" /> Office
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Layout>;
}